import AdminRouter from "@/pages/admin/router"
import EntriesRouter from "@/pages/entries/router"
import FinancialRouter from "@/pages/financial/router"
import ProcsRouter from "@/pages/procs/router"

const routers = [
  AdminRouter,
  EntriesRouter,
  FinancialRouter,
  ProcsRouter,
]

export default routers
